export default function deletePDP(){
	return `mutation DeletePDP(
		$_id: String
	) {
		deletePDP(
			_id: $_id
		)
	}`;
}
